'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _managed_ownable_contract_wrapper = require('./managed_ownable_contract_wrapper');

var _managed_ownable_contract_wrapper2 = _interopRequireDefault(_managed_ownable_contract_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PoolsNodesManagerWrapper = function (_ManagedOwnableContra) {
  (0, _inherits3.default)(PoolsNodesManagerWrapper, _ManagedOwnableContra);

  function PoolsNodesManagerWrapper() {
    (0, _classCallCheck3.default)(this, PoolsNodesManagerWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (PoolsNodesManagerWrapper.__proto__ || Object.getPrototypeOf(PoolsNodesManagerWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(PoolsNodesManagerWrapper, [{
    key: 'getContractName',
    get: function get() {
      return 'poolsNodesManager';
    }
  }]);
  return PoolsNodesManagerWrapper;
}(_managed_ownable_contract_wrapper2.default); /*
                                               Copyright: Ambrosus Inc.
                                               Email: tech@ambrosus.io
                                               
                                               This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0. If a copy of the MPL was not distributed with this file, You can obtain one at https://mozilla.org/MPL/2.0/.
                                               
                                               This Source Code Form is “Incompatible With Secondary Licenses”, as defined by the Mozilla Public License, v. 2.0.
                                               */

exports.default = PoolsNodesManagerWrapper;